import React from 'react';
import PropTypes from 'prop-types';

class SharesRow extends React.Component {
  state = {
    deleteMode: false
  }

  toggleDeleteMode = () => {
    this.setState((prevState) => ({
      deleteMode: !prevState.deleteMode,
      editMode: !prevState.deleteMode ? false : prevState.editMode
    }));
  }

  deleteShare = () => {
    const { share, deleteShareManifest } = this.props;
    deleteShareManifest(share.key);
  }

  renderShare() {
    const {
      availability_end,
      created_at,
      created_by,
      digest,
      internal,
      name,
      require_identification,
      shareable_type
    } = this.props.share;
    const { assetCount } = this.props;
    return (
      <React.Fragment>
        <span className="thirty">
          <a href={`/s/${digest}`}>
            { (name && name.length > 40) ? `${name.substring(0, 40)}...` : name }
          </a>
        </span>
        <span className="fifteen" title={created_by}>
          {created_by}
        </span>
        <span className="ten center">
          {assetCount}
        </span>
        <span className="ten center">
          {internal ? bfTranslate("Restricted") : bfTranslate("Public")}
        </span>
        <span className="seven center">
          { this.props.formatDate(created_at) }
        </span>
        <span className="eight center">
          { this.props.formatDate(availability_end) || "-" }
        </span>
        <span className="five center">
          {require_identification ? bfTranslate("Required") : "-"}
        </span>
        <span className="edit-share five center">
          {shareable_type === 'AssetGroup' && (
            <a href={`/s/${digest}?show_edit_share_mode=true`} rel="noopener noreferrer" target="_blank">
              {bfTranslate('Edit')}
            </a>
          )}
        </span>
        <button
          className="delete-share five center"
          onClick={this.toggleDeleteMode}
          onKeyUp={this.toggleDeleteMode}
          type="button"
        >
          <span className=" bff-trash" />
        </button>
      </React.Fragment>
    );
  }

  renderDelete() {
    const { name, digest } = this.props.share;
    return (
      <span className="delete-share-mode">
        <span className="thirty">
          <a href={`/s/${digest}`}>
            { name && name.length > 40 ? `${name.substring(0, 40)}...` : name }
          </a>
        </span>
        <div className="delete-buttons">
          <button
            className="button tertiary cancel"
            onClick={this.toggleDeleteMode}
            type="button"
          >
            {bfTranslate("Cancel")}
          </button>
          <button
            className="button warning"
            onClick={this.deleteShare}
            type="button"
          >
            {bfTranslate("Delete Share Link")}
          </button>
        </div>
      </span>
    );
  }

  render() {
    const { deleteMode } = this.state;
    if (deleteMode) { return this.renderDelete(); }
    return this.renderShare();
  }
}

SharesRow.propTypes = {
  share: PropTypes.shape({
    name: PropTypes.string,
    created_at: PropTypes.string,
    availability_end: PropTypes.string,
    digest: PropTypes.string,
    internal: PropTypes.bool,
    require_identification: PropTypes.bool,
    created_by: PropTypes.string,
    shareable_type: PropTypes.string,
  }).isRequired,
  deleteShareManifest: PropTypes.func.isRequired,
  formatDate: PropTypes.func.isRequired,
  assetCount: PropTypes.number.isRequired
};

export default SharesRow;
